import { memo } from "react";
import { flexRender } from "@tanstack/react-table";
import classNames from "classnames";

import SelectBrands from "../SelectBrands/SelectBrands";
import { TableHeaderProps } from "./types";
import { EyeIcon, SentimentPositiveIcon, TrophyIcon } from "../../../icons";

import styles from "./TableHeader.module.css";



const TableHeader = memo(function TableHeader({ headerGroups, brands, onChangeBrand }: TableHeaderProps) {
  if (headerGroups.length === 0) return null;

  const firstHeaderGroup = headerGroups[0];

  return (
    <thead>
      <tr>
        {firstHeaderGroup.headers.map((header) => {
          const isRowTitleColumn = header.column.id === "models" || header.column.id === "prompts";
          const isBrandColumn = header.column.id.startsWith("brand_group_");
          const shouldDrawDividerLeft = isBrandColumn;

          if (isRowTitleColumn) {
            return (
              <th
                key={header.id}
                className={styles["table__row-title-header"]}
              >
                {flexRender(header.column.columnDef.header, header.getContext())}
              </th>
            );
          }

          if (header.isPlaceholder) {
            return (
              <th
                key={header.id}
                className={classNames(
                  styles["table__header-placeholder"],
                  shouldDrawDividerLeft && styles["divider-left"],
                )}
                aria-hidden="true"
              />
            );
          }

          if (isBrandColumn) {
            return (
              <th
                key={header.id}
                className={classNames(shouldDrawDividerLeft && styles["divider-left"])}
              >
                <div className={styles["table__brand-header-top"]}>
                  <div className={styles["table__brand-header-title"]}>
                    {flexRender(header.column.columnDef.header, header.getContext())}
                  </div>
                  <div className={styles["table__brand-header-select"]}>
                    {brands && onChangeBrand && (
                      <SelectBrands
                        brands={brands}
                        onChangeBrand={(brand) => onChangeBrand(header.id, brand)}
                      />
                    )}
                  </div>
                </div>
              </th>
            );
          }

          return (
            <th
              key={header.id}
            >
              {flexRender(header.column.columnDef.header, header.getContext())}
            </th>
          );
        })}
      </tr>

      <tr className={styles["table__header-icons-row"]}>
        {firstHeaderGroup.headers.map((header) => {
          const isRowTitleColumn = header.column.id === "models" || header.column.id === "prompts";
          const isBrandColumn = header.column.id.startsWith("brand_group_");

          if (isRowTitleColumn) {
            return (
              <th
                key={`${header.id}-empty`}
                className={styles["table__header-placeholder"]}
                aria-hidden="true"
              />
            );
          }

          if (header.isPlaceholder) {
            return (
              <th
                key={`${header.id}-empty`}
                className={styles["table__header-placeholder"]}
                aria-hidden="true"
              />
            );
          }

          if (!isBrandColumn) {
            return (
              <th
                key={`${header.id}-empty`}
                className={styles["table__header-placeholder"]}
                aria-hidden="true"
              />
            );
          }

          return (
            <th 
              key={`${header.id}-icons`}
              className={styles["table__header-icons-cell"]}
            >
              <div className={styles["table__brand-header-bottom"]}>
                <EyeIcon aria-label="Visibility" />
                <SentimentPositiveIcon aria-label="Sentiment" />
                <TrophyIcon aria-label="Ranking" />
              </div>
            </th>
          );
        })}
      </tr>
    </thead>
  );
});

export default TableHeader;

